import { useContext } from "react";
import { GameState } from "./GameState";

const Messages = () => {
  const state = useContext(GameState);
  const baseMarginTop = 720;
  const maxMessageCount = 9;
  const messageColors = {
    good: "#00ff00",
    bad: "#ff0000",
    neutral: "#ffffff",
  };

  return (
    <div className="messagecontainer">
      {state.mapMessages.map((msg) => {
        const color = messageColors[msg.type];
        const styles = {
          left: msg.position.x,
          top: msg.position.y,
          color: color,
        };
        return (
          <div className="map-message" style={styles}>
            {msg.text}
          </div>
        );
      })}
      {state.messages.slice(0).reverse().slice(0, maxMessageCount).map((msg, idx) => {
        const marginTop = baseMarginTop - 30 * idx + "px";
        const color = messageColors[msg.type];
        return (
          <div
            className="message"
            style={{ marginTop: marginTop, color: color }}
          >
            {msg.text}
          </div>
        );
      })}
    </div>
  );
};

export default Messages;
